import './MerchantAndOfferStatus.scss';
import React from 'react';

import {
  MERCHANT_VERIFICATION_STATUSES,
  OFFER_VERIFICATION_STATUSES,
  OFFER_STATUSES,
  STATUS_ENTITIES,
} from 'pages/MerchantPortal/merchant-portal.types';

import StatusBadge, { STATUS_TYPES } from 'components/Shared/StatusBadge/StatusBadge';
import { STATUS_MAP } from './constants';

type MerchantAndOfferStatusProps = {
  type: STATUS_ENTITIES;
  status: MERCHANT_VERIFICATION_STATUSES | OFFER_VERIFICATION_STATUSES | OFFER_STATUSES;
  showTooltip?: boolean;
  customTooltipText?: string;
};

export default function MerchantAndOfferStatus(props: MerchantAndOfferStatusProps) {
  const { type, status, showTooltip, customTooltipText } = props;

  const statusInfo = STATUS_MAP[type];
  const title = statusInfo?.[status]?.title || '';
  const description = statusInfo?.[status]?.description || '';

  const statusBadgeType =
    Object.values(STATUS_TYPES).find((p) => p === (status as string)) || STATUS_TYPES.STATUS_VERIFIED;

  return (
    <StatusBadge
      status={statusBadgeType}
      title={title}
      tooltip={customTooltipText ?? description}
      showTooltip={showTooltip}
    />
  );
}
